import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { AccordionDetails, Typography } from "@mui/material";
import { getUserWiseBankDetails } from "../../store/actions";

const BankUpdateDetail = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserWiseBankDetails());
  }, []);

  const getUserWiseBankDetailsResponse = useSelector(
    (state) => state.bankUpdateDetail.getUserWiseBankDetails.responseData
  );

  console.log("bankUpdateDetailSagas", getUserWiseBankDetailsResponse);
  return (
    <>
      {getUserWiseBankDetailsResponse && getUserWiseBankDetailsResponse.length > 0 && (
        <table border="1" cellPadding="10" style={{ borderCollapse: 'collapse', width: '100%' }}>
          <thead>
            <tr>
              <th>Mark code</th>
              <th>Mark name</th>
              <th>Entity code</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {getUserWiseBankDetailsResponse.map((data, index) => (
              <tr key={index}>
                <td>{data?.markCode || '-'}</td>
                <td>{data?.markName || '-'}</td>
                <td>{data?.userCode || '-'}</td>
                <td style={{ display: 'flex', gap: '10px' }}>
                  {data?.bankStatus === 0 && (
                    <form
                      action="https://www.b2biz.co.in/ws/registerBankInfo"
                      method="post"
                    >
                      <input type="hidden" name="walletClientCode" value="WT-1572" />
                      <input
                        type="hidden"
                        name="walletRequestMessage"
                        value={data?.createWalletRequestMessage}
                      />
                      <button className="SubmitBtn" type="submit" style={{ marginTop: '0px' }}>
                        Register With Bank
                      </button>
                    </form>
                  )}

                  {data?.bankStatus === 1 && (
                    <>
                      <form
                        action="https://www.b2biz.co.in/ws/modifyBankInfo"
                        method="post"
                      >
                        <input type="hidden" name="walletClientCode" value="WT-1572" />
                        <input
                          type="hidden"
                          name="walletRequestMessage"
                          value={data?.updateWalletRequestMessage}
                        />
                        <button className="SubmitBtn ml-3" type="submit" style={{ marginTop: '0px' }}>
                          Update Bank Details
                        </button>
                      </form>

                      <form
                        action="https://www.b2biz.co.in/ws/viewBankInfo"
                        method="post"
                      >
                        <input type="hidden" name="walletClientCode" value="WT-1572" />
                        <input
                          type="hidden"
                          name="walletRequestMessage"
                          value={data?.viewWalletRequestMessage}
                        />
                        <button className="SubmitBtn ml-3" type="submit" style={{ marginTop: '0px' }}>
                          View Bank Details
                        </button>
                      </form>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default BankUpdateDetail;
